import { createAction } from "redux-act";
import { ITriviaStatsContest } from "modules/types";


export const fetchContestStat = createAction();
export const fetchContestStatSuccess = createAction<ITriviaStatsContest>();
